import { render, staticRenderFns } from "./wordSheet.vue?vue&type=template&id=198734d8&scoped=true&"
import script from "./wordSheet.vue?vue&type=script&lang=js&"
export * from "./wordSheet.vue?vue&type=script&lang=js&"
import style0 from "./wordSheet.vue?vue&type=style&index=0&id=198734d8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198734d8",
  null
  
)

export default component.exports